require('./soundcloud.api');
require('./soundcloud.player.api');

const SC = window.SC;
const soundcloud = window.soundcloud;

delete window.SC;
delete window.soundcloud;
export { SC, soundcloud };
